export const appHead = {"meta":[{"charset":"utf-8"},{"name":"theme-color","content":"#29705E"},{"name":"format-detection","content":"telephone=no"},{"name":"mobile-web-app-capable","content":"yes"},{"name":"apple-mobile-web-app-capable","content":"yes"},{"name":"application-name","content":"Mycovergenius"},{"name":"apple-mobile-web-app-title","content":"Mycovergenius"},{"name":"viewport","content":"width=device-width, initial-scale=1, shrink-to-fit=no"},{"property":"og:site_name","content":"MyCoverGenius"},{"property":"og:locale","content":"en_NG"},{"property":"og:image","content":"https://res.cloudinary.com/dzhhy3ovo/image/upload/v1727082972/health-coverage_gpptol.png"}],"link":[{"rel":"preconnect","href":"https://api.mycovergenius.com"},{"rel":"preconnect","href":"https://cdn.jsdelivr.net","crossorigin":"anonymous"},{"rel":"preconnect","href":"https://www.googletagmanager.com","crossorigin":"anonymous"},{"rel":"prefetch","href":"https://mcg-individual-dashboard.vercel.app/"},{"rel":"prefetch","href":"https://mcg-business.vercel.app/"},{"rel":"icon","type":"image/x-icon","href":"/favicon.png"}],"style":[],"script":[{"defer":true,"src":"/js/google.js"}],"noscript":[{"innerHTML":"This website requires JavaScript to run."}],"charset":"utf-8","htmlAttrs":{"lang":"en"},"templateParams":{"siteName":"MyCoverGenius","separator":"|"},"base":{"href":"/"}}

export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = ""

export const appLayoutTransition = false

export const appPageTransition = false

export const appViewTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appRootAttrs = {"id":"__nuxt"}

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const appSpaLoaderTag = "div"

export const appSpaLoaderAttrs = {"id":"__nuxt-loader"}

export const renderJsonPayloads = true

export const componentIslands = true

export const payloadExtraction = true

export const cookieStore = true

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"componentName":"NuxtLink","prefetch":true,"prefetchOn":{"visibility":true}}

export const asyncDataDefaults = {"value":null,"errorValue":null,"deep":true}

export const resetAsyncDataToUndefined = true

export const nuxtDefaultErrorValue = null

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false

export const appId = "nuxt-app"

export const outdatedBuildInterval = 3600000

export const multiApp = false

export const chunkErrorEvent = "vite:preloadError"

export const crawlLinks = false

export const spaLoadingTemplateOutside = false

export const purgeCachedData = true

export const granularCachedData = false

export const pendingWhenIdle = true

export const alwaysRunFetchOnKeyChange = true